<div *ngrxLet="viewModel$; let model;"
  class="rowMenuContainer"
  [ngClass]="{focusedCell: model.isFocused}">

  <!--No `alt` because of performance reasons
  (angular's internal .setAttribute method tends to be slow)-->
  <ng-template #myBusinessIcon>
    <img src="assets/images/google/my_business.svg"
      alt height="24" width="24"/>
    </ng-template>

    <ng-template #searchIcon>
      <img src="assets/images/google/google.svg"
        alt height="24" width="24"/>
      </ng-template>

      <ng-template #mapsIcon>
        <img src="https://storage.googleapis.com/lsc-tmp-images/maps.svg"
          alt height="24" width="24"/>
        </ng-template>


        <div id="rowMenuLinkContainer">
          <div class="link-container">
            @if (model.params?.data?.myBusinessLocationUrl) {
              <a
                href="{{model.params.data.myBusinessLocationUrl}}"
                target="_blank"
                rel="noopener noreferrer"
                matTooltip="Go to GBP account"
                appGtagEvent
                trackOn="click"
                action="open link"
                category="Navigation [overhaul]"
                [params]="{event_label: 'Open location in Google MyBusiness'}">
                <span class="enabledImg">
                  <span [ngTemplateOutlet]="myBusinessIcon"></span>
                </span>
              </a>
            }
            @if (!model.params?.data?.myBusinessLocationUrl) {
              <span
                class="disabledImg"
                matTooltip="This location doesn't have a GBP account">
                <span [ngTemplateOutlet]="myBusinessIcon"></span>
              </span>
            }
          </div>

          <div class="link-container">
            @if (model.params?.data?.searchUrl) {
              <a
                href="{{model.params.data.searchUrl}}"
                target="_blank"
                rel="noopener noreferrer"
                matTooltip="Show this location on Google Search"
                appGtagEvent
                trackOn="click"
                action="open link"
                category="Navigation [overhaul]"
                [params]="{event_label: 'Open location in Google Search'}">
                <span class="enabledImg">
                  <span [ngTemplateOutlet]="searchIcon"></span>
                </span>
              </a>
            }
            @if (!model.params?.data?.searchUrl) {
              <span
                class="disabledImg"
                matTooltip="This location is not on Google Search">
                <span [ngTemplateOutlet]="searchIcon"></span>
              </span>
            }
          </div>

          <div class="link-container">
            @if (model.params?.data?.mapsUrl) {
              <a
                href="{{model.params.data.mapsUrl}}"
                target="_blank"
                rel="noopener noreferrer"
                matTooltip="Show this location on Google Maps"
                appGtagEvent
                trackOn="click"
                action="open link"
                category="Navigation [overhaul]"
                [params]="{event_label: 'Open location in Google Maps'}">
                <span class="enabledImg">
                  <span [ngTemplateOutlet]="mapsIcon"></span>
                </span>
              </a>
            }
            @if (!model.params?.data?.mapsUrl) {
              <span
                class="disabledImg"
                matTooltip="This location is not on Google Maps">
                <span [ngTemplateOutlet]="mapsIcon"></span>
              </span>
            }
          </div>

          <div class="link-container">
            <button mat-icon-button
              [matMenuTriggerFor]="rowMenu.rowActionMenu"
              [matMenuTriggerData]="{location: model.params?.data}"
              class="rowMenuButton"
              matTooltip="Show action menu"
              appGtagEvent
              trackOn="click"
              action="show action menu"
              category="Single-location action [overhaul]"
              [params]="{event_label: 'Show parent location action menu on menu button click'}">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
          </div>
        </div>

        <mat-divider vertical class="mx-2"></mat-divider>

        <div #markerIconContainer
          class="h-10 w-10 flex items-center justify-center relative"
          (click)="onMarkerSvgClick(model)">
      <img [ngSrc]="model.markerLocation?.url && !model.isCvOn ? model.markerLocation.url.default :
              'assets/images/mapMarkers/default_marker_icon.png'"
            width="24"
            height="33"
           [ngClass]="{ 'grayscale': !model?.markerLocation?.url || model.isCvOn,
                          'opacity-20': !model?.markerLocation?.url || model.isCvOn,
                          'cursor-pointer': model?.markerLocation?.url && !model.isCvOn }"
            alt/>
            <span #markerLabel
            class="markerLabel">{{ model.markerLocation?.url && !model.isCvOn ? model.markerLocation?.label.text : '' }}</span>
          </div>
        </div>


        <app-row-menu #rowMenu></app-row-menu>
